import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import ICSErrorCard from '../../../components/ICSErrorCard/ICSErrorCard'
import { useAppSelector } from '../../../hooks/useAppSelector'
import ResultsGrid from './ResultsGrid'
import { LoadIndicator } from 'devextreme-react'

const ResultsBox: React.FC = () => {
  const loading = useAppSelector((state) => state.results.loading)
  const error = useAppSelector((state) => state.results.error)

  if (loading) {
    return <LoadIndicator />
  }

  if (error) {
    return (
      <ICSErrorCard
        title="An error occurred"
        message={error.message}
        code={error.code}
        fields={error.fields}
      />
    )
  }

  return (
    <Container fluid={true}>
      <Row>
        <Col xs={12} className="px-0">
          <ResultsGrid />
        </Col>
      </Row>
    </Container>
  )
}

export default ResultsBox
